<template>
    <MessageRemoteImages v-if="blocked_images.length && show_load_remote_images === true"
      @loadRemoteImages="onLoadRemoteImages()"
    />

    <div class="message-wrapper">
<!--
        <div class="theme-toggle">
            <input id="toggle1" type="checkbox" checked tabindex="-1">
            <label for="toggle1" @click="onToggleLightMode()">
                <div class="label-text">Claro</div>
                <div class="switch" tabindex="0"></div>
                <div class="label-text">Escuro</div>
            </label>
        </div>
-->

        <div
          ref="message_body"
          class="message-body"
          :class="{'light-mode' : light_mode}"
          v-html="props.message.body_parts">
        </div>
    </div>
</template>

<script setup>
  import {nextTick, ref}            from 'vue';
  import {defineProps, defineEmits} from 'vue';
  import {onMounted}                from 'vue';
  import MessageRemoteImages        from './MessageRemoteImages.vue';
  import LayoutSettingsController   from '@/js/Webmail/LayoutSettingsController';

  const props = defineProps({
    message : {
      required: true,
    },

    show_load_remote_images: {
      default: true,
    }
  });

  const emit = defineEmits([
    'attachmentClick', 'iframeClick', 'bodyLoaded', 
  ])

  const message_body   = ref(null);
  const light_mode     = ref(false);
  const blocked_images = ref([]);
  let   images         = [];
  let   iframes        = [];
  const initial_size   = ref(0);
  const current_size   = ref()


  onMounted(async () => {
    parseIframes();
    parseIframesElements();
    parseAttachmentsPreviews();
    await nextTick();
    resizeMessageBody();
    emit('bodyLoaded');
  })

  const onToggleLightMode = () => {
    light_mode.value = !light_mode.value;
    (light_mode.value === true) ? setIframeClass('light-mode') : removeIframeClass('light-mode');
  }

  const onIframeclick = () => {
    emit('iframeClick');
  }

  const onAttachmentClick = (attachment_id, preview) => {
    emit('attachmentClick', attachment_id, preview);
  }

  const onLoadRemoteImages = () => {
    loadRemoteImages();
    resizeMessageBody();
  }

  const parseIframes = async () => {
    for (let id in props.message.body) {
      let iframe       = document.getElementById(id);
      iframe.setHeight = 0;
      iframe.contentWindow.document.open();
      iframe.contentWindow.document.write(props.message.body[id].contents);
      iframe.contentWindow.document.close();
      iframe.contentWindow.addEventListener('resize', resizeMessageBody);
      iframe.contentWindow.addEventListener('click', onIframeclick);

      iframes.push(iframe);
    }
  }

  const parseIframesElements = () => {
    iframes.forEach((iframe) => {
      setIframeCSS(iframe);
      setImages(iframe);
      setBlockedImages(iframe);
    });
  }

  const parseAttachmentsPreviews = () => {
    let links = message_body.value.getElementsByTagName('a');

    for (let i = 0; i < links.length; i++) {
      let preview = links[i].getAttribute('data-attach-preview');

      if (preview) {
        links[i].onclick = () => {
          onAttachmentClick(links[i].getAttribute('data-mime-part-id'), preview);
        }
      }
    }
  };

  const setIframeCSS = (iframe) => {
    var head   = iframe.contentWindow.document.getElementsByTagName('head')[0];
    var link   = document.createElement('link');
    link.rel   = 'stylesheet';
    link.type  = 'text/css';
    link.href  = 'css/message_body.css';
    link.media = 'all';

    iframe.contentWindow.document.getElementsByTagName('body')[0].classList.add(LayoutSettingsController.theme);
    iframe.contentWindow.document.getElementsByTagName('body')[0].classList.add(LayoutSettingsController.color_scheme);
    head.appendChild(link);
  }

  const setIframeClass = (value) => {
    iframes.forEach((iframe) => {
      iframe.contentWindow.document.getElementsByTagName('body')[0].classList.add(value);
    });
  }

  const removeIframeClass = (value) => {
    iframes.forEach((iframe) => {
      iframe.contentWindow.document.getElementsByTagName('body')[0].classList.remove(value);
    });
  }

  const setImages = (iframe) => {
    images = iframe.contentWindow.document.getElementsByTagName('img');

    for (let i = 0; i < images.length; i++) {
      let src     = images[i].getAttribute('data-src');

      if (src) {
        images[i].setAttribute('src', src);
        images[i].removeAttribute('data-src');
        images[i].onload = resizeMessageBody;
      }
    }
  }

  const setBlockedImages = (iframe) => {
    blocked_images.value = iframe.contentWindow.document.querySelectorAll('[htmlimgblocked]');
  }

  const loadRemoteImages = () => {
    for (let i = 0; i < blocked_images.value.length; i++) {
      let src = blocked_images.value[i].getAttribute('htmlimgblocked');

      if (blocked_images.value[i].hasAttribute('src') || blocked_images.value[i].tagName.toLowerCase() === 'img') {
        blocked_images.value[i].setAttribute('src', src);
        blocked_images.value[i].removeAttribute('htmlimgblocked');
        blocked_images.value[i].onload = resizeMessageBody;
        continue;
      }

      if (blocked_images.value[i].hasAttribute('background')) {
        blocked_images.value[i].setAttribute('background', src);
        blocked_images.value[i].removeAttribute('htmlimgblocked');
        continue;
      }

      blocked_images.value[i].style.backgroundImage = `url(${src})`;
      blocked_images.value[i].removeAttribute('htmlimgblocked');
    }

    blocked_images.value = [];
  }

  const resizeMessageBody = () => {
    iframes.forEach((iframe) => {

      let height = Math.max(
        iframe.contentWindow.document.body.scrollHeight,
        iframe.contentWindow.document.documentElement.scrollHeight,
        iframe.contentWindow.document.body.offsetHeight,
        iframe.contentWindow.document.documentElement.offsetHeight,
        iframe.contentWindow.document.body.clientHeight,
        iframe.contentWindow.document.documentElement.clientHeight
      );

      if (iframe.setHeight === height) {
        return;
      }

      iframe.setHeight    = height;
      iframe.style.height = height + 'px';
    })
  }

  const cleanup = () => {
    iframes = [];
  }

</script>